/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BaseRepairEstimateProfileListItemDto } from '../model/baseRepairEstimateProfileListItemDto';
import { RepairEstimateFieldsVisibilityDto } from '../model/repairEstimateFieldsVisibilityDto';
import { RepairEstimateProfileDto } from '../model/repairEstimateProfileDto';
import { RepairEstimateProfileListItemDto } from '../model/repairEstimateProfileListItemDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RepairEstimateProfileViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:GET/api/RepairEstimateProfileView/List AmsResource:{country}/{business}/RepairEstimateProfile/_* 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getList(observe?: 'body', reportProgress?: boolean): Observable<Array<RepairEstimateProfileListItemDto>>;
    public getList(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RepairEstimateProfileListItemDto>>>;
    public getList(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RepairEstimateProfileListItemDto>>>;
    public getList(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<RepairEstimateProfileListItemDto>>(`${this.basePath}/api/RepairEstimateProfileView/List`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/RepairEstimateProfileView/country/{countryId}/List AmsResource:{country}/_* 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getListOfBaseProfiles(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BaseRepairEstimateProfileListItemDto>>;
    public getListOfBaseProfiles(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BaseRepairEstimateProfileListItemDto>>>;
    public getListOfBaseProfiles(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BaseRepairEstimateProfileListItemDto>>>;
    public getListOfBaseProfiles(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getListOfBaseProfiles.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BaseRepairEstimateProfileListItemDto>>(`${this.basePath}/api/RepairEstimateProfileView/country/${encodeURIComponent(String(countryId))}/List`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/RepairEstimateProfileView/{profileId} AmsResource:{country}/{business}/_* 
     * @param profileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProfile(profileId: string, observe?: 'body', reportProgress?: boolean): Observable<RepairEstimateProfileDto>;
    public getProfile(profileId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RepairEstimateProfileDto>>;
    public getProfile(profileId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RepairEstimateProfileDto>>;
    public getProfile(profileId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (profileId === null || profileId === undefined) {
            throw new Error('Required parameter profileId was null or undefined when calling getProfile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RepairEstimateProfileDto>(`${this.basePath}/api/RepairEstimateProfileView/${encodeURIComponent(String(profileId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/RepairEstimateProfileView/country/{countryId}/fieldsVisibility AmsResource:{country}/{business}/_* 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRepairEstimateFieldsVisibility(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<RepairEstimateFieldsVisibilityDto>;
    public getRepairEstimateFieldsVisibility(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RepairEstimateFieldsVisibilityDto>>;
    public getRepairEstimateFieldsVisibility(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RepairEstimateFieldsVisibilityDto>>;
    public getRepairEstimateFieldsVisibility(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getRepairEstimateFieldsVisibility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RepairEstimateFieldsVisibilityDto>(`${this.basePath}/api/RepairEstimateProfileView/country/${encodeURIComponent(String(countryId))}/fieldsVisibility`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/RepairEstimateProfileView/country/{countryId}/business/{businessId}/List AmsResource:{country}/{business}/_* 
     * @param countryId 
     * @param businessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRepairEstimateProfileList(countryId: string, businessId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RepairEstimateProfileListItemDto>>;
    public getRepairEstimateProfileList(countryId: string, businessId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RepairEstimateProfileListItemDto>>>;
    public getRepairEstimateProfileList(countryId: string, businessId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RepairEstimateProfileListItemDto>>>;
    public getRepairEstimateProfileList(countryId: string, businessId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getRepairEstimateProfileList.');
        }

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling getRepairEstimateProfileList.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<RepairEstimateProfileListItemDto>>(`${this.basePath}/api/RepairEstimateProfileView/country/${encodeURIComponent(String(countryId))}/business/${encodeURIComponent(String(businessId))}/List`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
